import React from 'react';
import { Box, Skeleton, Card, CardContent, Grid } from '@mui/material';

export const TableSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => (
  <Box>
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} height={48} sx={{ mb: 1, borderRadius: 1 }} />
    ))}
  </Box>
);

export const CardsSkeleton: React.FC<{ count?: number }> = ({ count = 4 }) => (
  <Grid container spacing={2}>
    {Array.from({ length: count }).map((_, i) => (
      <Grid item xs={12} sm={6} md={3} key={i}>
        <Card variant="outlined">
          <CardContent>
            <Skeleton width="40%" />
            <Skeleton height={36} sx={{ my: 1 }} />
            <Skeleton width="60%" />
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
);

export default TableSkeleton;
